/* src/app/forms/wizard-configuracao/properties-value-view/properties-value-view.component.scss */
.prop-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=properties-value-view.component.css.map */
